import type { TComponentModule } from "../types";

export const loadComponents = async (loaders: Array<() => Promise<TComponentModule>>) => {
  const componentLoadResults = await Promise.allSettled(
    loaders.map((loader) => loader()),
  );

  const loadedComponents = componentLoadResults
    .filter((result): result is PromiseFulfilledResult<TComponentModule> => result.status === "fulfilled")
    .map((result) => new result.value.default());

  const componentInitResults = await Promise.allSettled(
    loadedComponents.map((component) => Promise.resolve(component.init())),
  );

  componentLoadResults.forEach((result, index) => {
    if (result.status === "rejected") {
      console.error(`Failed to load component #${index + 1}`, result.reason);
    }
  });

  componentInitResults.forEach((result, index) => {
    if (result.status === "rejected") {
      console.error(`Failed to init component #${index + 1}`, result.reason);
    }
  });
};

